import React from 'react';

import Graphic, { doesGraphicExist } from '@ui/Graphic';
import Icon from '@ui/Icon';

interface Props {
  platform?: string | false;
}

const UserAgentPlatformGraphic = React.memo(function UserAgentPlatformGraphic({ platform }: Props) {
  const hasGraphic = doesGraphicExist(platform ? platform.toLowerCase() : false);

  if (platform && platform.length && hasGraphic) {
    return <Graphic name={platform.toLowerCase()} />;
  }

  return <Icon color="gray60" name="help-circle" size="sm" />;
});

export default UserAgentPlatformGraphic;
